module.exports = __webpack_public_path__ + "static/media/animal-horse1.63d53ad5.aac";